var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-10 col-sm-11 pr-0" },
          [
            _c("app-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|max:40",
                  expression: "'required|max:40'"
                }
              ],
              attrs: {
                label: "Group name",
                name: "pricing-name-" + _vm.pricingId,
                id: "pricing-name-" + _vm.pricingId,
                type: "text"
              },
              model: {
                value: _vm.name,
                callback: function($$v) {
                  _vm.name = $$v
                },
                expression: "name"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.canRemove
          ? _c(
              "div",
              {
                staticClass:
                  "col-2 col-sm-1 d-flex align-items-center justify-content-center cursor-pointer mb-2 p-0",
                on: { click: _vm.onRemove }
              },
              [
                _c("img", {
                  attrs: {
                    src: require("../../../../assets/img/delete-red.svg")
                  }
                })
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("choice", {
        attrs: { options: _vm.types },
        model: {
          value: _vm.type,
          callback: function($$v) {
            _vm.type = $$v
          },
          expression: "type"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-xl-6" },
          [
            _c("select-box", {
              attrs: {
                label: "From",
                "default-value": _vm.rangeStartValue,
                "data-list": _vm.rangeList
              },
              on: { selected: _vm.onRangeStartSelect }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-xl-6" },
          [
            _c("select-box", {
              attrs: {
                label: "To",
                "default-value": _vm.rangeEndValue,
                "data-list": _vm.rangeList
              },
              on: { selected: _vm.onRangeEndSelect }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      !_vm.rangeValid && _vm.formValid
        ? _c("div", { staticClass: "error range-error" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.type) +
                " from should be after " +
                _vm._s(_vm.type) +
                " to\n        "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("time-picker", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|timeBefore:timeTo",
                  expression: "'required|timeBefore:timeTo'"
                }
              ],
              attrs: {
                id: "time-from",
                label: "Time from",
                "default-hours": 9,
                "default-minutes": 0
              },
              model: {
                value: _vm.timeFrom,
                callback: function($$v) {
                  _vm.timeFrom = $$v
                },
                expression: "timeFrom"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("time-picker", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              ref: "timeTo",
              attrs: {
                id: "time-to",
                label: "To",
                "default-hours": 12,
                "default-minutes": 0
              },
              model: {
                value: _vm.timeTo,
                callback: function($$v) {
                  _vm.timeTo = $$v
                },
                expression: "timeTo"
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6565b1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6565b1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/pages/camp-form/CampPricingCreate.vue
// module id = null
// module chunks = 